<template>
  <div>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1">Pilih Usulan</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2">Data ASN</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3">Upload Berkas</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">Preview</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <FtRegistrasiLayananDesc1></FtRegistrasiLayananDesc1>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="selanjutnyaStep2">Selanjutnya</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <FtRegistrasiLayananDesc2 class="mb-5"></FtRegistrasiLayananDesc2>
          <div class="d-flex">
            <v-btn color="secondary" @click="step = 1">Sebelumnya</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="selanjutnyaStep3">Selanjutnya</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="3">
          <FtRegistrasiLayananDoc class="mb-4"></FtRegistrasiLayananDoc>

          <div class="d-flex">
            <v-btn color="secondary" @click="step = 2">Sebelumnya</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="selanjutnyaStep4">Selanjutnya</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="4">
<!--          <v-text-field label="Password" outlined></v-text-field>-->
          <FtRegistrasiLayananSummary class="mb-5"></FtRegistrasiLayananSummary>
          <div class="d-flex">
            <v-btn color="secondary" @click="step = 3">Sebelumnya</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary"  @click="submit">Submit</v-btn>
          </div>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import FtRegistrasiLayananDesc1 from "@/components/public_registrasi_diklat_edit/FtRegistrasiLayananDesc1.vue";
import FtRegistrasiService from "@/services/apiservices/ft-registrasi-service";
import FDivisionService from "@/services/apiservices/f-division-service";
import FJenisDokumenService from "@/services/apiservices/f-jenis-dokumen-service";
import FTemplateRegService from "@/services/apiservices/f-template-reg-service";
import FtRegistrasiLayananDesc2 from "@/components/public_registrasi_diklat_edit/FtRegistrasiLayananDesc2.vue";
import FtRegistrasiFileService from "@/services/apiservices/ft-registrasi-file-service";
import FTemplateRegDokumenService from "@/services/apiservices/f-template-reg-dokumen-service";
import FtRegistrasiLayananDoc from "@/components/public_registrasi_diklat_edit/FtRegistrasiLayananDoc.vue";
import FtRegistrasiLayananSummary from "@/components/public_registrasi_diklat_edit/FtRegistrasiLayananSummary.vue";

export default {
  name: "FtRegistrasiLayananEditStepper",
  components: {
    FtRegistrasiLayananSummary,
    FtRegistrasiLayananDoc,
    FtRegistrasiLayananDesc2,
    FtRegistrasiLayananDesc1
  },
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    currentUser(){
      return this.$store.state.auth.user;
    },

    itemModified:{
      get(){
        return this.$store.state.FtRegistrasiModule.itemModified
      },
      set(val) {
        this.$store.dispatch('FtRegistrasiModule/updateItemModified', val)
      }
    },

    itemsFDivision: {
      get(){
        return this.$store.state.FTemplateRegModule.itemsFDivision
      },
      set (value){
        this.$store.dispatch('FTemplateRegModule/updateItemsFDivision', value)
      }
    },
    itemsFJenisDokumen: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFJenisDokumen
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFJenisDokumen', value)
      }
    },
    itemsFJenisJabatan: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFJenisJabatan
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFJenisJabatan', value)
      }
    },
    itemsFJenisProsedur: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFJenisProsedur
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFJenisProsedur', value)
      }
    },
    itemsFJenisKenaikanPangkat: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFJenisKenaikanPangkat
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFJenisKenaikanPangkat', value)
      }
    },
    itemsFJenisKartu: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFJenisKartu
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFJenisKartu', value)
      }
    },
    itemsFTemplateReg: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFTemplateReg
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFTemplateReg', value)
      }
    },
    itemsFTemplateRegDokumen: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFTemplateRegDokumen
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFTemplateRegDokumen', value)
      }
    },
    itemFTemplateRegBean: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemFTemplateRegBean
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemFTemplateRegBean', value)
      }
    },
    itemsFtRegistrasiFile: {
      get(){
        return this.$store.state.FtRegistrasiModule.itemsFtRegistrasiFile
      },
      set (value){
        this.$store.dispatch('FtRegistrasiModule/updateItemsFtRegistrasiFile', value)
      }
    },

  },
  methods: {
    submit() {
      this.itemModified.submitted = true
      FtRegistrasiService.updateFtRegistrasi(this.itemModified).then(
          response=>{
            this.itemModified = response.data
            this.$router.push('/registrasi-layanan')
          },
          error=>{
            console.log(error.response)
          }
      )
    },
    selanjutnyaStep2(){
      this.step = 2
      this.saveFirst()
    },
    selanjutnyaStep3(){
      this.step = 3
      this.saveFirst()
      /**
       * Jika FtRegistrasiFile tipe Doc masih kosong maka buatkan
       */

      FtRegistrasiFileService.getAllFtRegistrasiFileByFtRegistrasiBeanAndFileType(this.itemModified.id, "DOC").then(
          response =>{
            if (response.data.length ===0){
              this.createFtRegistrasiFileFirst()
            }else {
              this.itemsFtRegistrasiFile = response.data
            }
          }
      )

    },
    selanjutnyaStep4(){
      this.step = 4
      this.saveFirst()
    },
    saveFirst(){
      // console.log(JSON.stringify(this.itemModified))

      FtRegistrasiService.updateFtRegistrasi(this.itemModified).then(
          response=>{
            this.itemModified = response.data
            // console.log(JSON.stringify(response.data))
          },
          error=>{
            console.log(error.response)
          }
      )
    },

    createFtRegistrasiFileFirst(){
      const payloadMulti ={
        ftRegistrasiBean: this.itemModified.id,
        fileType: "DOC",
        ftemplateRegDokumenIds: this.itemsFTemplateRegDokumen.map(item => item.id)
      }
      FtRegistrasiFileService.createFtRegistrasiFileMulti(payloadMulti).then(
          response => {
            this.itemsFtRegistrasiFile = response.data
          }
      )

    },
    fetchFtRegistrasiFile(ftRegistrasiBean){
      FtRegistrasiFileService.getAllFtRegistrasiFileByFtRegistrasiBeanAndFileType(ftRegistrasiBean, "DOC").then(
          response =>{
            this.itemsFtRegistrasiFile = response.data
          }
      )
    },

    fetchParent(){
      if (this.currentUser.organizationLevel === "DIV") {
        FDivisionService.getFDivisionById(this.currentUser.fdivisionBean).then(
            response=>{
              this.itemsFDivision = [response.data]
              // console.log(response.data.items)
            },
            error=>{
              console.log(error.response)
            }
        )

      }else {
        FDivisionService.getAllFDivision().then(
            response => {
              this.itemsFDivision = response.data
            },
            error => {
              console.log(error.response)
            }
        )
      }
      FJenisDokumenService.getAllFJenisDokumen().then(
          response => {
            this.itemsFJenisDokumen = response.data
          },
          error => {
            console.log(error.response)
          }
      )
      FTemplateRegService.getAllFTemplateReg().then(
          response => {
            // console.log(JSON.stringify(response.data))
            this.itemsFTemplateReg = response.data
          },
          error => {
            console.log(error.response)
          }
      )
    },

  },
  mounted() {

    //Reset dlu lah
    this.itemModified = []

    this.itemsFtRegistrasiFile = []
    this.itemsFTemplateReg = []
    this.itemsFTemplateRegDokumen = []
    this.itemFTemplateRegBean = []


    console.log("Mulai FtRegistrasiLayananEditStepper")
    this.fetchParent()

    const id = this.$route.params.id;
    FtRegistrasiService.getFtRegistrasiById(id).then((response) => {

      this.itemModified = response.data;
      this.fetchFtRegistrasiFile(this.itemModified.id)

      FTemplateRegDokumenService.getAllFTemplateRegDokumenByParent(this.itemModified.ftemplateRegBean).then(
          response=>{
            this.itemsFTemplateRegDokumen = response.data
          },
          error=>{
            console.log(error.response)
          }
      )
    });


  }

}
</script>

<style scoped>

</style>